import { NgModule } from '@angular/core';
import { HierarchyChartComponent } from './hierarchy-chart.component';



@NgModule({
  declarations: [HierarchyChartComponent],
  imports: [
  ],
  exports: [HierarchyChartComponent]
})
export class NgxHierarchyChartModule { }
